import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AuthService, Size } from '../auth.service';

@Component({
  selector: 'app-size',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './size.component.html',
  styleUrl: './size.component.css'
})
export class SizeComponent implements OnInit {
  sizes: Size[] = [];
  selectedSize: Size = { id: 0, title: '' };
  isUpdating = false;
  errorMessage = '';

  constructor(private authService: AuthService) { }

  ngOnInit(): void {
    this.getSizes();
  }

  getSizes(): void {
    this.authService.getSize().subscribe(
      (sizes) => (this.sizes = sizes),
      (error) => (this.errorMessage = 'Erreur lors du chargement des tailles.')
    );
  }

  saveSize(): void {
    if (this.isUpdating) {
      this.authService.updateSize(this.selectedSize.id, this.selectedSize).subscribe(
        () => this.getSizes(),
        (error) => (this.errorMessage = 'Erreur lors de la mise à jour de la taille.')
      );
    } else {
      this.authService.createSize(this.selectedSize).subscribe(
        () => this.getSizes(),
        (error) => (this.errorMessage = 'Erreur lors de la création de la taille.')
      );
    }
    this.isUpdating = false;
    this.selectedSize = { id: 0, title: '' };
  }

  editSize(size: Size): void {
    this.selectedSize = { ...size };
    this.isUpdating = true;
  }

  deleteSize(id: number): void {
    this.authService.deleteSize(id).subscribe(
      () => this.getSizes(),
      (error) => (this.errorMessage = 'Erreur lors de la suppression de la taille.')
    );
  }
}
